<template>
  <div
    class="py-1 px-2 mr-5 rounded-md bg-blue-800 dark:bg-gray-700 text-white dark:text-blue-400 max-[1066px]:flex max-[1066px]:items-center max-[1066px]:justify-center"
  >
    Admin
  </div>
</template>
<script setup lang="ts"></script>
